import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"
import ImportFichados from "./Imports/ImportFichados"
import acusacionOptions from "../../common/acusacionOptions"

const AdminLitigioComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  const [showImportExcel, setShowImportExcel] = React.useState(false)
  const toggleImportExcel = () => {
    setShowImportExcel(!showImportExcel)

  }
  return (<>
    {showImportExcel && <ImportFichados toggle={toggleImportExcel} />}
    <CRUD
      id="litigio"

      isModal={false}
      cssClass="modalRight"
      recordButtonsPosition="start"
      filterOpen={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Litigios") ?? ""}
      icon={"fas fa-users"}
      getRecordsPath={`litigio/list`}
      addEditRecordPath={`litigio/addEdit?currentUserId=${user.ID}`}
      deleteRecordPath="litigio/delete"
      filterFields={[

        {
          name: "nombre",
          htmlType: "text",
          dbType: "string",
          title: t("No. Orden Judicial") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

      ]}
      fieldsList={[
        {
          name: "tipoDocumento",
          title: t("Tipo Documento"),
          htmlType: "informe"
        },
        {
          name: "acusacion",
          title: t("Acusación"),
        },
        {
          name: "materia",
          title: t("Materia"),
        },
        {
          name: "noOrdenJudicial",
          title: t("No. Orden Judicial"),
        },

      ]}

      fields={[
        { name: "id", htmlType: "hidden", dbType: "string" },
        {
          name: "anonimo", required: true, htmlType: "select", dbType: "bit", title: t("Anonimo") ?? "", containerClass: "col-12 col-md-6"
          , dataSourceLocal: [{ id: true, name: t("Sí") }, { id: false, name: t("No") }], dataSourceTextField: "name", dataSourceValueField: "id"
        },
        { name: "separator", dbType: "string", title: t("Demandante") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "demandanteCedula", htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "demandanteNombre", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "demandantePrimerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "demandanteSegundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "demandanteFoto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },

        { name: "separator", dbType: "string", title: t("Representante") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "representanteLegalCedula", htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "representanteLegalNombre", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "representanteLegalPrimerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "representanteLegalSegundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "representanteLegalFoto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },

        { name: "separator", dbType: "string", title: t("Imputado") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "imputadoCedula", htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "imputadoNombre", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "imputadoPrimerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "imputadoSegundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "imputadoFoto", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },

        { name: "separator", dbType: "string", title: t("Caso") ?? "", htmlType: "separator", containerClass: "col-12" },
        {
          name: "litigioTipoDocumentoId", dbType: "string", title: t("Tipo Documento") ?? "", htmlType: "select", containerClass: "col-12 col-md-6",
          dataSource: "litigioTipoDocumento/list", dataSourceTextField: "name", dataSourceValueField: "id", required: true,
          datasourceMethod: "POST"
        },
        {
          name: "litigioAcusacionId", dbType: "string", title: t("Acusación") ?? "", htmlType: "select", containerClass: "col-12 col-md-6",
          dataSource: "litigioAcusacion/list", dataSourceTextField: "name", dataSourceValueField: "id", required: true,
          datasourceMethod: "POST"
        },
        {
          name: "litigioMateriaId", dbType: "string", title: t("Materia") ?? "", htmlType: "select", containerClass: "col-12 col-md-6",
          dataSource: "litigioMateria/list", dataSourceTextField: "name", dataSourceValueField: "id", required: true,
          datasourceMethod: "POST"
        },
        {
          name: "fotoDocumento", dbType: "string", title: t("Foto Documento") ?? "", htmlType: "picture", containerClass: "col-12 col-md-6"
        },
        { name: "noOrdenJudicial", htmlType: "text", dbType: "string", title: t("No. Orden Judicial") ?? "", containerClass: "col-12 col-md-6", required: true },

        { name: "separator", dbType: "string", title: t("Fuentes") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "enlace1", htmlType: "text", dbType: "string", title: t("Enlace 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace2", htmlType: "text", dbType: "string", title: t("Enlace 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace3", htmlType: "text", dbType: "string", title: t("Enlace 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace4", htmlType: "text", dbType: "string", title: t("Enlace 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace5", htmlType: "text", dbType: "string", title: t("Enlace 5") ?? "", containerClass: "col-12 col-md-6" },

      ]}

    />
  </>
  )
}

export default AdminLitigioComponent
